// Slugs returned by the API are lowercase with underscores (e.g. "vfd_bank",
// "safe_haven", "monnify"). Render them as proper provider names.

const ACRONYMS = new Set(["vfd", "ussd", "nip", "bvn", "atm"]);

export const prettifyPaymentOptionName = (raw?: string | null): string => {
  if (!raw) return "Unknown";
  return raw
    .toString()
    .trim()
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((word) =>
      ACRONYMS.has(word.toLowerCase())
        ? word.toUpperCase()
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .join(" ");
};
